import { transport } from 'config/transport';

export function callApiExportCongDoanYearlyReport(congDoanId, academicYear, pdf = false) {
    return transport.get(`/congdoan/${congDoanId}/thuchi/exportReportAnnually`, { params: { academicYear, pdf }, responseType: 'blob' });
}
